
import axios from 'axios'
import { environment } from "@/data/environment";

export async function getListRoles() {
  try {
    const response = await axios.get(
      environment.HIOPOSWEBSERVICES + "/api/getRoles/1"
    );
    const roles = response.data.data;
    return roles.map(role => ({
      textRol: role.name,
      valueRol: role.name
    }))
  } catch (error) {
    console.error('❌ Error cargando roles:', error)
    return []
  }
}
